import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Profile } from './types';
import { API_URL, API_ENDPOINTS } from './config/api';

declare global {
  interface Window {
    ENV?: {
      API_URL?: string;
    };
  }
}

const App: React.FC = () => {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState<boolean>(true);


  useEffect(() => {
    // Fetch profile data
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}${API_ENDPOINTS.PROFILE}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setProfile(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching profile:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <Header profile={profile} />
      <main>
        <About profile={profile} />
        <Contact />
      </main>
      <Footer profile={profile} />
    </div>
  );
};

export default App;
